import { UppClientOptions } from '../client/interfaces'
import { SUPPORTED_BRANDS } from '../config'

export type SettingsKey = keyof UppClientOptions

export const requiredStringSettings: SettingsKey[] = [
  'portal',
  'category'
]

export const optionalStringSettings: SettingsKey[] = [
  'xUIApp',
  'stage',
  'section',
  'tagid',
  'layoutclass',
  'smAdiUrl',
  'forceContent',
  'contentGroup',
  'touchpointName',
  'touchpointReference'
]

export const optionalFunctionSettings: SettingsKey[] = [
  'onContentInfoReceived',
  'onShowContent',
  'onContentMessage',
  'getContentUrl',
]

export function validateSettings(settings: UppClientOptions): void {
  if (!settings) {
    throw new Error('Missing settings object!')
  }

  if (!settings.accessToken && typeof settings.getContentUrl !== 'function') {
    throw new Error(`Required setting 'accessToken' must have a string value if getContentUrl is not a function!`)
  }

  requiredStringSettings.forEach((name) => {
    if (!settings[name] || typeof settings[name] !== 'string') {
      throw new Error(`Required setting '${name}' must have a string value!`)
    }
  })

  if (!SUPPORTED_BRANDS.includes(settings.portal)) {
    throw new Error(`Invalid value ${settings.portal} for setting 'portal': Must be one of ${SUPPORTED_BRANDS.join(', ')}!`)
  }

  optionalStringSettings.forEach((name) => {
    if (!!settings[name] && typeof settings[name] !== 'string') {
      throw new Error(`Optional setting '${name}' must have a string value!`)
    }
  })

  optionalFunctionSettings.forEach((name) => {
    if (!!settings[name] && typeof settings[name] !== 'function') {
      throw new Error(`Optional setting '${name}' must be a function!`)
    }
  })

  if (!!settings.contentContainer &&
    !(settings.contentContainer instanceof HTMLElement) && typeof settings.contentContainer !== 'function') {
    throw new Error('Optional setting contentContainer must be an HTML element or a function')
  }

  if (settings.campaign && typeof settings.campaign !== 'string' && !(settings.campaign instanceof Array)) {
    throw new Error('Optional setting campaign must be a string or Array of strings')
  }

  if (settings.campaign && settings.campaign instanceof Array && settings.campaign.find(entry => typeof entry !== 'string')) {
    throw new Error('Array value for optional setting campaign may only contain strings')
  }

  if (!!settings.smAdiUrl && !!settings.getContentUrl) {
    throw new Error(`The value of 'smAdiUrl' will be ignored if 'getContentUrl' is defined`)
  }
}

